export * from '../../../lib/upload-file-policy';
import {
  isIllustratorUpload,
  getGeneralAgentUploadMimeType,
} from '../../../lib/upload-file-policy';

export function isBrowserPreviewableUploadMimeType(mimeType: string): boolean {
  const normalized = mimeType.trim().toLowerCase();
  return (
    normalized === 'image/png' ||
    normalized === 'image/jpeg' ||
    normalized === 'image/jpg' ||
    normalized === 'image/webp' ||
    normalized === 'image/gif' ||
    normalized === 'image/avif' ||
    normalized === 'video/mp4' ||
    normalized === 'video/webm'
  );
}

export function canPreviewUpload(file: File): boolean {
  return isBrowserPreviewableUploadMimeType(
    getGeneralAgentUploadMimeType(file)
  );
}

export function inferWorkspaceFileMimeType(args: {
  path: string;
  mimeType?: string | null;
}): string {
  if (
    isIllustratorUpload({
      filename: args.path,
      mimeType: args.mimeType,
    })
  ) {
    return 'application/vnd.adobe.illustrator';
  }
  const explicitMimeType = args.mimeType?.trim();
  if (explicitMimeType && explicitMimeType !== 'application/octet-stream') {
    return explicitMimeType;
  }
  const normalized = args.path.toLowerCase();
  if (/\.(?:png)$/i.test(normalized)) return 'image/png';
  if (/\.(?:jpe?g)$/i.test(normalized)) return 'image/jpeg';
  if (/\.(?:webp)$/i.test(normalized)) return 'image/webp';
  if (/\.(?:gif)$/i.test(normalized)) return 'image/gif';
  if (/\.(?:svg)$/i.test(normalized)) return 'image/svg+xml';
  if (/\.(?:mp4)$/i.test(normalized)) return 'video/mp4';
  if (/\.(?:webm)$/i.test(normalized)) return 'video/webm';
  if (/\.(?:mov)$/i.test(normalized)) return 'video/quicktime';
  if (/\.(?:stl)$/i.test(normalized)) return 'model/stl';
  if (/\.(?:pdf)$/i.test(normalized)) return 'application/pdf';
  if (/\.(?:ai)$/i.test(normalized)) {
    return 'application/vnd.adobe.illustrator';
  }
  if (/\.(?:psd)$/i.test(normalized)) return 'image/vnd.adobe.photoshop';
  if (/\.(?:md|mdx)$/i.test(normalized)) return 'text/markdown';
  if (/\.(?:json)$/i.test(normalized)) return 'application/json';
  if (/\.(?:txt)$/i.test(normalized)) return 'text/plain';
  return 'application/octet-stream';
}

/**
 * Single factory for client-generated upload ids so every upload pipeline
 * shares the same id shape and entropy source.
 */
export function createComposerUploadId(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  return `upload-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}
